import { render, staticRenderFns } from "./tab-rejected.vue?vue&type=template&id=09fbd8b2&scoped=true"
import script from "./tab-rejected.vue?vue&type=script&lang=js"
export * from "./tab-rejected.vue?vue&type=script&lang=js"
import style0 from "./tab-rejected.vue?vue&type=style&index=0&id=09fbd8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fbd8b2",
  null
  
)

export default component.exports